import { z } from "zod";

export const reinterventionReasonDtoSchema = z.object({
  id: z.number(),
  enabled: z.boolean(),
  note: z.string(),
  description: z.string(),
});

export type TReinterventionReasonDto = z.infer<typeof reinterventionReasonDtoSchema>;
